export default __webpack_public_path__ + "static/media/how-it-works-author.49709397.svg";